import React, { Component } from "react";
import {  Paper, Container } from "@material-ui/core";
export default class Wrappercontainer extends Component {
  render() {
    var maxWidth = "lg";
    if (this.props.large) {
      maxWidth = "xl";
    }

    return (
      <Container maxWidth={maxWidth}>
        <Paper
          elevation={3}
          style={{marginTop: 50 }}
        >
          {this.props.children}
        </Paper>
      </Container>
    );
  }
}
